function togglePopup(el,handle=null) {
    let popup = document.querySelector('.quick-add-popup')
    let body = document.querySelector('body')
    popup.classList.toggle('show')
    body.classList.toggle('overflow')
    if(handle){
      loadQuickAdd(handle)
    } else {
      popup.innerHTML = ''
    }
  }
  async function loadQuickAdd(handle) {
    try {
      const url = `/products/${handle}?view=quick-add`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      const html = await response.text();
      const quick_add_box = document.querySelector('.quick-add-popup')
      quick_add_box.innerHTML = html;
      quick_add_box.querySelectorAll('.product-option').forEach(option => {
        option.querySelectorAll('input[type="radio"]').forEach(radio => {
          radio.addEventListener('change', () => {
            const label = option.querySelector('.option-selected');
            if (label) label.textContent = radio.value;
          });
        });
      });
    } catch (err) {
      console.error("Quick add error:", err);
    }
  }